import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

export function TrialCounter() {
  const { user, isPremium } = useAuth();
  if (!user || isPremium()) return null;
  const n = user.trial_credits ?? 0;
  const label = n > 0 ? `${n} analisis gratis tersisa` : "0 analisis gratis tersisa";
  return (
    <span data-testid="trial-counter" className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1 rounded-full ${n > 0 ? "bg-teal/10 text-teal" : "bg-amber-100 text-amber-700"}`}>
      <Sparkles className="w-3.5 h-3.5" />{label}
    </span>
  );
}
